module.exports = __webpack_public_path__ + "static/git-integration-63f4076c55ec748d09edf1160bf5b1c1.png";